export const types = {
  INIT_PURCHASE: 'FORM_MOBILE_LINE/INIT_PURCHASE',
  INIT_PURCHASE_SUCCESS: 'FORM_MOBILE_LINE/INIT_PURCHASE_SUCCESS',
  SET_INFO: 'FORM_MOBILE_LINE/SET_INFO',
  SET_INFO_SUCCESS: 'FORM_MOBILE_LINE/SET_INFO_SUCCESS',
  CHECKOUT_REQUEST: 'FORM_MOBILE_LINE/CHECKOUT_REQUEST',
  CHECKOUT_REQUEST_SUCCESS: 'FORM_MOBILE_LINE/CHECKOUT_REQUEST_SUCCESS',
  PROCESS_ORDER: 'FORM_MOBILE_LINE/PROCESS_ORDER',
  PROCESS_ORDER_SUCCESS: 'FORM_MOBILE_LINE/PROCESS_ORDER_SUCCESS',
  SET_SEGMENT: 'FORM_MOBILE_LINE/SET_SEGMENT',
  SEND_PURCHASE_OTP: 'FORM_MOBILE_LINE/SEND_PURCHASE_OTP',
  VALIDATE_PURCHASE_OTP: 'FORM_MOBILE_LINE/VALIDATE_PURCHASE_OTP',
  SEND_PORTABILITY_OTP: 'FORM_MOBILE_LINE/SEND_PORTABILITY_OTP',
  VALIDATE_PORTABILITY_OTP: 'FORM_MOBILE_LINE/VALIDATE_PORTABILITY_OTP',
  VALIDATE_ALL_OTPS: 'FORM_MOBILE_LINE/VALIDATE_ALL_OTPS',
  SET_LINE_OPTION_SELECTED: 'FORM_MOBILE_LINE/SET_LINE_OPTION_SELECTED',
};

export const actions = {
  initPurchase: (data) => ({
    type: types.INIT_PURCHASE,
    payload: { data },
  }),
  initPurchaseSuccess: (data) => ({
    type: types.INIT_PURCHASE_SUCCESS,
    payload: { data },
  }),
  setInfo: (data) => ({
    type: types.SET_INFO,
    payload: { data },
  }),
  setInfoSuccess: (data) => ({
    type: types.SET_INFO_SUCCESS,
    payload: { data },
  }),
  checkout: (data) => ({
    type: types.CHECKOUT_REQUEST,
    payload: { data },
  }),
  checkoutSuccess: (data) => ({
    type: types.CHECKOUT_REQUEST_SUCCESS,
    payload: { data },
  }),
  processOrder: (data) => ({
    type: types.PROCESS_ORDER,
    payload: { data },
  }),
  processOrderSuccess: (data) => ({
    type: types.PROCESS_ORDER_SUCCESS,
    payload: { data },
  }),
  setSegment: (data) => ({
    type: types.SET_SEGMENT,
    payload: { data },
  }),
  sendPurchaseOtp: (data) => ({
    type: types.SEND_PURCHASE_OTP,
    payload: { data },
  }),
  validatePurchaseOtp: (data) => ({
    type: types.VALIDATE_PURCHASE_OTP,
    payload: { data },
  }),
  sendPortabilityOtp: (data) => ({
    type: types.SEND_PORTABILITY_OTP,
    payload: { data },
  }),
  validatePortabilityOTP: (data) => ({
    type: types.VALIDATE_PORTABILITY_OTP,
    payload: { data },
  }),
  validateAllOTPs: (data) => ({
    type: types.VALIDATE_ALL_OTPS,
    payload: { data },
  }),
  setLineOptionSelected: (data) => ({
    type: types.SET_LINE_OPTION_SELECTED,
    payload: { data },
  }),
};

const initialState = {
  loadingForm: false,
  loadingShoppingCart: false,
  initialShoppingCart: null,
  shoppingCart: null,
  customerInfo: null,
  lines: null,
  linesOptionsSelected: null,
  shippingType: null,
  shippingTexts: null,
  checkout: false,
  segment: null,
  actions: '',
};

/* eslint-disable default-param-last */
function reducer(state = { ...initialState }, action) {
  switch (action.type) {
    case types.INIT_PURCHASE: {
      return {
        ...state,
        loadingForm: true,
      };
    }
    case types.INIT_PURCHASE_SUCCESS: {
      const { data } = { ...action.payload };
      const {
        shoppingCartInfoNormalized,
        customerInfoNormalized,
        lines,
        shippingType = null,
        purchaseOptions,
        orionTexts,
      } = {
        ...data,
      };
      return {
        ...state,
        loadingForm: false,
        initialShoppingCart: shoppingCartInfoNormalized,
        shoppingCart: shoppingCartInfoNormalized,
        customerInfo: customerInfoNormalized,
        lines,
        linesOptionsSelected: lines.map((item) => {
          return {
            [item?.operation?.lineAction?.fieldId]:
              item?.operation?.lineAction?.fieldValue,
            [item?.operation?.simType?.fieldId]:
              item?.operation?.simType?.fieldValue,
            [item?.operation?.portabilityPhone?.fieldId]:
              item?.operation?.portabilityPhone?.fieldValue,
          };
        }),
        shippingType,
        purchaseOptions,
        orionTexts,
      };
    }
    case types.INIT_PURCHASE_ERROR: {
      return {
        ...state,
        loadingForm: false,
      };
    }
    case types.SET_INFO: {
      const { data } = { ...action.payload };
      const { skipCheckCoverage } = { ...data };
      return {
        ...state,
        loadingShoppingCart: !skipCheckCoverage,
      };
    }
    case types.SET_INFO_SUCCESS: {
      const { data } = { ...action.payload };
      const { shoppingCart, shippingType } = { ...data };
      return {
        ...state,
        loadingShoppingCart: false,
        shoppingCart,
        shippingType,
      };
    }
    case types.SET_INFO_ERROR: {
      return {
        ...state,
        loadingShoppingCart: false,
      };
    }
    case types.CHECKOUT_REQUEST: {
      return {
        ...state,
        checkout: true,
      };
    }
    case types.CHECKOUT_REQUEST_SUCCESS: {
      const { data } = { ...action.payload };
      return {
        ...state,
        checkout: false,
        actions: data,
      };
    }
    case types.CHECKOUT_REQUEST_ERROR: {
      return {
        ...state,
        checkout: false,
      };
    }
    case types.SET_SEGMENT: {
      const { data } = { ...action.payload };
      const { segment } = { ...data };
      return {
        ...state,
        segment,
      };
    }
    case types.SET_LINE_OPTION_SELECTED: {
      const { data } = { ...action.payload };
      const { name, value } = { ...data };
      return {
        ...state,
        linesOptionsSelected: {
          ...state.linesOptionsSelected,
          [name]: value,
        },
      };
    }
    default:
      return state;
  }
}

export default reducer;
